module.exports = __webpack_public_path__ + "static/media/A cyberpunk dystopia where neon lights illuminate towering skyscrapers.1ec857ee.jpeg";